function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M179.765,305.626c16.256,24.887,44.355,41.37,76.235,41.37c50.176,0,90.996-40.821,90.996-90.996 s-40.82-90.996-90.996-90.996s-90.996,40.82-90.996,90.996c0,17.666,5.066,34.168,13.813,48.142 C179.083,304.658,179.403,305.153,179.765,305.626z M256,326.996c-22.264,0-42.158-10.31-55.185-26.397l30.257-30.257l20.96,20.959 c3.906,3.905,10.236,3.904,14.143,0l57.312-57.312c2.268,6.934,3.51,14.328,3.51,22.01C326.996,295.147,295.147,326.996,256,326.996 z M256,185.004c23.955,0,45.16,11.937,58.024,30.163l-54.921,54.921l-20.96-20.959c-3.906-3.905-10.236-3.904-14.143,0 l-33.712,33.712c-3.397-8.286-5.285-17.345-5.285-26.841C185.004,216.852,216.852,185.004,256,185.004z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M409.845,249.101c-1.571-48.868-15.246-96.792-39.792-139.167C343.92,64.82,306.201,27.263,260.974,1.325 c-3.08-1.767-6.869-1.767-9.949,0C205.799,27.263,168.08,64.82,141.946,109.933c-24.546,42.375-38.221,90.299-39.792,139.167 C67.098,264.144,44,298.76,44,337.351V408c0,5.523,4.478,10,10,10h146.941c2.155,30.079,15.324,58.889,36.883,80.131l11.157,10.993 c1.946,1.917,4.482,2.876,7.019,2.876c2.537,0,5.072-0.959,7.019-2.876l11.157-10.993c21.559-21.242,34.728-50.051,36.883-80.13H342 v51.612c0,5.523,4.478,10,10,10s10-4.477,10-10V418h96c5.522,0,10-4.477,10-10v-70.648C468,298.76,444.901,264.144,409.845,249.101z  M256,21.597C287.442,40.516,314.32,65.27,335.574,94H176.426C197.68,65.27,224.558,40.516,256,21.597z M122,258.588 c0-36.21,7.152-71.494,20.428-104.088h45.279c5.522,0,10-4.477,10-10s-4.478-10-10-10h-36.194c3.515-6.992,7.326-13.831,11.417-20.5 h186.14C375.355,156.854,390,206.772,390,258.588V388c0,5.514-4.486,10-10,10H132c-5.514,0-10-4.486-10-10V258.588z M64,337.351 c0-27.495,14.81-52.442,38-65.844V388c0,3.506,0.61,6.87,1.72,10H64V337.351z M260.139,483.884L256,487.962l-4.139-4.078 c-17.769-17.507-28.747-41.135-30.858-65.884h69.994C288.885,442.749,277.907,466.377,260.139,483.884z M448,398h-39.72 c1.11-3.13,1.72-6.494,1.72-10V271.508c23.19,13.401,38,38.348,38,65.844V398z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M224,154.5c2.63,0,5.21-1.07,7.069-2.93c1.86-1.86,2.931-4.44,2.931-7.07s-1.07-5.21-2.931-7.07 c-1.859-1.86-4.439-2.93-7.069-2.93s-5.21,1.07-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.07s1.069,5.21,2.93,7.07 S221.37,154.5,224,154.5z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M160,444.751c-5.522,0-10,4.477-10,10v30.806c0,5.523,4.478,10,10,10s10-4.477,10-10v-30.806 C170,449.228,165.522,444.751,160,444.751z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M352,492c-2.63,0-5.21,1.07-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.07s1.069,5.21,2.93,7.07S349.37,512,352,512 s5.21-1.07,7.069-2.93c1.86-1.86,2.931-4.44,2.931-7.07s-1.07-5.21-2.931-7.07C357.21,493.07,354.63,492,352,492z"
});

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

function SvgArocketsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC96B"
    },
    d: "M301.377,409.25L301.377,409.25c0,30.735-12.327,60.186-34.221,81.757L256,502l-11.157-10.993 c-21.893-21.571-34.221-51.022-34.221-81.757l0,0H301.377z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5D5D"
    },
    d: "M112,388V258.588c0-0.864,0.014-1.725,0.021-2.588H112l0,0c-34.708,11.968-58,44.638-58,81.351V408 h78C120.954,408,112,399.045,112,388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5D5D"
    },
    d: "M400,256L400,256h-0.021c0.008,0.863,0.021,1.724,0.021,2.588V388c0,11.046-8.954,20-20,20h78 v-70.649C458,300.638,434.708,267.968,400,256z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5F8D2"
    },
    d: "M256,10L256,10L256,10c-89.068,51.082-144,145.912-144,248.588V388c0,11.046,8.954,20,20,20h248 c11.046,0,20-8.954,20-20V258.588C400,155.912,345.068,61.082,256,10z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5D5D"
    },
    d: "M157.279,104H354.72C330.261,65.817,296.697,33.34,256,10l0,0l0,0 C215.303,33.34,181.739,65.817,157.279,104z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 256,
    cy: 256,
    r: 80.996
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0E557"
    },
    d: "M336.996,256c0-14.314-3.728-27.751-10.243-39.42l-67.65,67.65l-28.031-28.031l-43.349,43.349 c14.388,22.51,39.58,37.447,68.277,37.447C300.733,336.996,336.996,300.733,336.996,256z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArocketsLogo);
export default __webpack_public_path__ + "static/media/arockets-logo.80684ca5.svg";
export { ForwardRef as ReactComponent };